import { useCallback, useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";

/*
    Paginado compartido de todas las secciones.

    La pagina vive en la url (?pagina=2) para que se pueda compartir,
    recargar y volver con el boton atras del navegador sin perderla.

    Al cambiar de pagina saltamos al tope de golpe, sin animacion: la
    pagina nueva empieza arriba, como cuando abris una seccion.
*/

export const usePagedList = (items = [], initialPerPage = 6, paramKey = "page") => {

    const [useSearchParamsValue, setSearchParams] = useSearchParams();

    const [usePerPage, setPerPage] = useState(initialPerPage);

    const PAGE_FROM_URL = Number(useSearchParamsValue.get(paramKey)) || 1;

    const TOTAL = items.length;

    const IS_ALL = Number(usePerPage) === -1;

    const TOTAL_PAGES = IS_ALL ? 1 : Math.max(1, Math.ceil(TOTAL / Number(usePerPage)));

    const PAGE = Math.min(Math.max(PAGE_FROM_URL, 1), TOTAL_PAGES);

    const onWritePage = useCallback((page) => {

        setSearchParams((prev) => {

            const NEXT = new URLSearchParams(prev);

            if (page <= 1) NEXT.delete(paramKey);
            else NEXT.set(paramKey, String(page));

            return NEXT;

        }, { replace: true });

    }, [paramKey, setSearchParams]);

    // Si el filtro dejo la pagina actual fuera de rango, volvemos a la primera
    useEffect(() => {
        if (PAGE_FROM_URL > TOTAL_PAGES) onWritePage(1);
    }, [PAGE_FROM_URL, TOTAL_PAGES, onWritePage]);

    const PAGED = useMemo(() => {

        if (IS_ALL) return items;

        const FROM = (PAGE - 1) * Number(usePerPage);

        return items.slice(FROM, FROM + Number(usePerPage));

    }, [items, PAGE, usePerPage, IS_ALL]);

    const onChangePage = (page) => {
        onWritePage(page);
        window.scrollTo(0, 0);
    };

    const onChangePerPage = (value) => {
        setPerPage(value);
        onWritePage(1);
        window.scrollTo(0, 0);
    };

    return {
        usePage: PAGE,
        usePerPage,
        paged: PAGED,
        total: TOTAL,
        totalPages: TOTAL_PAGES,
        onChangePage,
        onChangePerPage,
    };
};
